<template>
    <v-dialog
        v-model="handleDialog"
        scrollable
        max-width="700px"
      >
        <v-card class="setting-card">
            <v-card-title>表示設定</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="setting-main">
                <div class="setting-row">  
                    <v-row class="pb-4">
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_name" :label="`件名`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_status" :label="`状態`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.signature_method" :label="`署名方式`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.close_date" :label="`締結/却下日時`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.sender_user_name" :label="`送信者`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6"  style="min-width: 212px;" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.sender_email_address" :label="`送信者メールアドレス`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.sender_company_name" :label="`送信者企業`"></v-checkbox>
                        </v-col>
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.sender_send_datetime" :label="`送信日時`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.next_remind_send_datetime" :label="`リマインド日時`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.antecedent_confirm_user_name" :label="`前の確認者`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6"  style="min-width: 212px;" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.antecedent_confirm_email_address" :label="`前の確認者メールアドレス`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.antecedent_confirm_company_name" :label="`前の確認者企業`"></v-checkbox>
                        </v-col>
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.antecedent_confirm_signature_datetime" :label="`前の確認日時`"></v-checkbox>
                        </v-col>
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.antecedent_confirm_signature_status" :label="`前の確認状況`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.next_confirm_user_name" :label="`次の確認者`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6"  style="min-width: 212px;" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.next_confirm_email_address" :label="`次の確認者メールアドレス`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.next_confirm_company_name" :label="`次の確認者企業`"></v-checkbox>
                        </v-col>
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.next_confirm_role" :label="`次の確認者役割`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6" style="min-width: 212px;" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.next_confirm_opening_status" :label="`次の確認者開封状況`"></v-checkbox>
                        </v-col>
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.next_confirm_expire" :label="`確認期限`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.last_confirm_user_name" :label="`最終署名者`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6" style="min-width: 212px;" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.last_confirm_email_address" :label="`最終署名者メールアドレス`"></v-checkbox>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.last_confirm_company_name" :label="`最終署名者企業`"></v-checkbox>
                        </v-col>
                        <v-col xl="3" lg="3" md="4" sm="6" xs="6" no-gutters>
                            <v-checkbox hide-details v-model="displaySetting.last_confirm_signature_datetime" :label="`最終署名日時`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-title">関係者</div>
                <v-data-table
                    loading-text="読込中"
                    :headers="headers"
                    dense
                    class="elevation-1"
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tbody>
                            <tr>
                                <th>関係者2</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_2"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_2"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_2"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_2"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_2"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_2"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者3</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_3"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_3"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_3"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_3"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_3"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_3"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者4</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_4"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_4"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_4"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_4"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_4"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_4"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者5</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_5"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_5"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_5"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_5"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_5"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_5"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者6</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_6"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_6"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_6"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_6"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_6"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_6"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者7</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_7"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_7"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_7"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_7"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_7"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_7"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者8</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_8"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_8"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_8"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_8"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_8"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_8"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者9</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_9"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_9"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_9"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_9"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_9"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_9"></v-checkbox></th>
                            </tr>
                            <tr>
                                <th>関係者10</th>
                              　<th><v-checkbox hide-details v-model="displaySetting.destination_user_name_10"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_email_address_10"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_company_name_10"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.destination_role_10"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_datetime_10"></v-checkbox></th>
                                <th><v-checkbox hide-details v-model="displaySetting.signature_status_10"></v-checkbox></th>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card-text>
            <section>
               <v-card-actions class="justify-center grey lighten-4 pb-6">
                    <v-btn min-width="150px" class="white--text handle-btn" color="blue-grey lighten-1" large @click="handleDialog = false">
                        <slot name="cancel-btn">閉じる</slot>
                    </v-btn>
                </v-card-actions> 
            </section>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            itemSettingDialog: Boolean,
            displaySetting: Object,
        },
        data() {
            return {
                headers:[
                    { text: "", sortable: false},
                    { text: "氏名", sortable: false},
                    { text: "メールアドレス", sortable: false},
                    { text: "会社名", sortable: false},
                    { text: "役割", sortable: false},
                    { text: "確認日時", sortable: false},
                    { text: "確認状況", sortable: false},
                ],

            };
        },
        computed: {
            handleDialog: {
                get() {
                    return this.itemSettingDialog;
                },
                set(value) {
                    window.localStorage.setItem('all_list_display_setting', JSON.stringify(this.displaySetting))
                    this.$emit('setDisplaySetting', this.displaySetting);
                    // 親コンポーネントへの通知
                    this.$emit('input', value);
                }
            },
    
        },
    };
</script>

<style scoped>
.setting-title{
    font-size:13px!important;
    font-weight: bold;
}
.setting-row{
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 10px;
    box-shadow: 1px 1px 1px #8080804f;
}
::v-deep .v-dialog{
    transform-origin: center center;
    width: 45%;
    height: 600px;
    background-color: white;
}

::v-deep .setting-card{
    display: flex;
    flex-flow: column;
    min-height: 100%;
    margin: 0;
}

::v-deep .setting-card .v-toolbar__content{
    font-size: 15px;
}

::v-ddep .setting-main{
    flex: 1;
}

::v-deep .v-input--selection-controls{
    margin-top: 0px !important;
    padding-top: 0px !important;
}

::v-deep .v-card__text .v-label {
    font-size: 1.2rem !important;
    color: black !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 1.2rem !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > th {
    font-size: 1.2rem !important;
}

::v-deep .handle-btn{
    height: 30px !important;
}

::v-deep .handle-btn .v-btn__content {
    font-size: 1.2rem !important;
}

::v-deep .v-card__title, .v-card__text {
    font-size: 1.5rem !important;
}
</style>